import LayoutPreview from './LayoutPreview';

export default LayoutPreview;
